<template>
    <div class="bg-white p-3">
            <PageHeaderUI
            back=""
            title="View Wallet Details"
            breadcrumb="Billings & Payments > My Transactions"
          />

          <div>
            <WalletDetails/>
          </div>
    </div>
</template>

<script>
  import PageHeaderUI from "@/components/Ondemand/UI/PageHeaderUI.vue";
  import WalletDetails from "@/components/Ondemand/Settings/WalletDetails.vue";

    export default {
        components: { PageHeaderUI, WalletDetails }
    }
</script>

<style lang="scss" scoped>

</style>